import { IconButton, Image } from '@kanbu/chatbot-ui';
import { Trans } from '@lingui/react/macro';
import { CircleHelp, Minus, MessagesSquare } from 'lucide-react';
import { memo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import headerDark from '@/assets/images/header-dark.png';
import headerKanbu from '@/assets/images/header-kanbu.png';
import headerLight from '@/assets/images/header-light.png';
import { useChatConfig } from '@/contexts/ChatConfigProvider';
import { useBoundStore } from '@/store/store';

import { NewThread } from './NewThread';
import { SimpleTooltip } from '../tooltip/SimpleTooltip';

export const TopBar = memo(function TopBar() {
  const { themeConfig } = useChatConfig();
  const themePreset = themeConfig?.preset;
  const headerImage =
    themePreset === 'kanbu'
      ? headerKanbu
      : themePreset === 'light'
        ? headerLight
        : headerDark;

  const { close, setUnread, pushRoute } = useBoundStore(
    useShallow(state => ({
      close: state.close,
      setUnread: state.setUnread,
      pushRoute: state.pushRoute,
    })),
  );

  /**
   * Close and clear unread messages.
   */
  const handleClose = () => {
    setUnread(0);
    close();
  };

  const handleThreads = () => {
    pushRoute('threads');
  };

  const handleSettings = () => {
    pushRoute('hint');
  };

  return (
    <div className='sticky top-0 flex h-14 flex-row items-center justify-between bg-chat-primary px-4 text-chat-primary-foreground'>
      <div className='flex items-center gap-3'>
        <Image
          className='h-5'
          src={themeConfig?.logo || headerImage}
          data-testid='top-bar-logo'
        />
      </div>
      <div className='flex gap-1'>
        <SimpleTooltip
          title={<Trans>Help</Trans>}
          asChild
          data-testid='help-button-tooltip'
        >
          <IconButton
            variant='ghost'
            onClick={handleSettings}
            data-testid='help-button'
          >
            <CircleHelp />
          </IconButton>
        </SimpleTooltip>
        <SimpleTooltip
          title={<Trans>Previous conversations</Trans>}
          asChild
          data-testid='threads-button-tooltip'
        >
          <IconButton
            variant='ghost'
            onClick={handleThreads}
            data-testid='threads-button'
          >
            <MessagesSquare />
          </IconButton>
        </SimpleTooltip>
        <NewThread />
        <SimpleTooltip
          title={<Trans>Minimize</Trans>}
          asChild
          data-testid='minimize-button-tooltip'
        >
          <IconButton
            variant='ghost'
            onClick={handleClose}
            data-testid='minimize-button'
          >
            <Minus />
          </IconButton>
        </SimpleTooltip>
      </div>
    </div>
  );
});
